import React from "react";
import { Container, Row, Col } from "reactstrap";

const SegmentsGrid = ({ data }) => {
    if (!data) return null;

    const { tagline, title, description, segments, styles } = data;

    return (
        <section
            className="segment-grid"
        // style={{
        //     background: styles?.background || "#fff",
        //     padding: "80px 0"
        // }}
        >
            <Container>
                {/* Header */}
                <div className="sec-head">
                    <p className="eyebrow">
                        {tagline}
                    </p>

                    <h2 className="mb-3" style={{ color: styles?.titleColor }}>
                        {title}
                    </h2>

                    <p className="mx-auto" style={{ maxWidth: "750px" }}>
                        {description}
                    </p>
                </div>

                {/* Cards */}
                <Row className="g-4 sol-grid">
                    {segments.map((item, index) => (
                        <Col md={6} key={index}>
                            <div className="segment-card d-flex p-4 h-100">
                                {/* Icon */}
                                <div className="segment-icon me-3">
                                    {item.icon}
                                </div>
                                {/* Content */}
                                <div>
                                    <h3 className="">{item.title}</h3>
                                    <p className="mb-0">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default SegmentsGrid;